import { hidde_preloader } from "@cozumel-reef-maps/web_general/js/ui/preloader.js";
import { convertirMXNaUSD, view_plans_payment, getSelectedPlan } from "@cozumel-reef-maps/web_general/js/utils/helpers.js";
import { alertas } from "@cozumel-reef-maps/web_general/js/ui/alerts.js";







var GLOBAL_PAYMENTS_JSON = "";

var total_pago = 199;




// La función por defecto que el Router llamará automáticamente al entrar a /Dashboard/index
export default function initDashboard(container) {
    hidde_preloader();
    
    // Tu lógica segura que busca elementos
    const reefsList = document.getElementById("reefs_list");
    if (reefsList) reefsList.style.display = "none";
    
    check_status_payment(); 


console.log("user id:"+ user_id)
console.log("reference_member:"+ reference_member)
    
    // Si necesitas meter HTML dinámico en el contenedor:
    // container.innerHTML = "<h1>Bienvenido al Panel</h1>";
}







function view_payments(){



   console.log(GLOBAL_PAYMENTS_JSON);

   
// ------------------------------
// ESTILOS DINÁMICOS
// ------------------------------
const styles = `
.ios-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.45);
  backdrop-filter: blur(10px);
  display: flex;
  justify-content: center;
  align-items: flex-end;
  transition: opacity .25s ease;
  opacity: 0;
  pointer-events: none;
  z-index: 9999;
}

.ios-overlay.show {
  opacity: 1;
  pointer-events: all;
}

.ios-modal {
  width: 90%;
  background: #fff;
  border-radius: 20px 20px 0 0;
  padding: 25px;
  position: relative;
  animation: slideUp .25s ease;
  max-height: 70%;
  overflow-y: auto;
}

@keyframes slideUp {
  from { transform: translateY(100px); opacity: 0; }
  to   { transform: translateY(0); opacity: 1; }
}

/* Botón circular X estilo iOS */
.ios-close {
  position: fixed;
  top: 12px;
  right: 12px;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: none;
  background: #dc3545;
  backdrop-filter: blur(6px);
  font-size: 20px;
  font-weight: bold;
  color: #333;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.ios-close:hover {
  background: rgba(0,0,0,0.15);
}

.pago-item {
  padding: 15px;
  border-bottom: 1px solid #eee;
}

.pago-item span {
  font-weight: bold;
  color: #444;
}
`;

const styleTag = document.createElement("style");
styleTag.textContent = styles;
document.head.appendChild(styleTag);

// Crear overlay
  const overlay = document.createElement("div");
  overlay.className = "ios-overlay";
  overlay.id = "overlayPagos";

  // Crear modal
  const modal = document.createElement("div");
  modal.className = "ios-modal";

  // Botón X
  const closeBtn = document.createElement("button");
  closeBtn.className = "ios-close";
  closeBtn.textContent = "✕";
  closeBtn.onclick = cerrarPagos;

  // Título
  const titulo = document.createElement("h2");
  titulo.textContent = "Payment History";

  // Contenedor lista
  const lista = document.createElement("div");

  // Construir pagos
  GLOBAL_PAYMENTS_JSON.pagos.forEach(p => {
    const item = document.createElement("div");
    item.className = "pago-item";
    item.innerHTML = `
      <div><span>ID:</span> ${p.id}</div>
      <div><span>Email:</span> ${p.email}</div>
      <div><span>Payment Date:</span> ${p.fecha_pago}</div>
      <div><span>Expiration:</span> ${p.fecha_vencimiento}</div>
      <div><span>Total Paid:</span> $${p.total_pago} MXN</div>
      <div><span>Reference:</span> ${p.referencia_venta}</div>
    `;
    lista.appendChild(item);
  });




  // Armar modal
  modal.appendChild(closeBtn);
  modal.appendChild(titulo);
  modal.appendChild(lista);

  // Colocar todo
  overlay.appendChild(modal);
  document.body.appendChild(overlay);

  // Mostrar con animación
  requestAnimationFrame(() => overlay.classList.add("show"));

  // Cerrar al tocar afuera
  overlay.addEventListener("click", (e) => {
    if (e.target === overlay) cerrarPagos();
  });
}







function cerrarPagos() {
  const overlay = document.getElementById("overlayPagos");
  if (!overlay) return;

  overlay.classList.remove("show");
  setTimeout(() => overlay.remove(), 250);
}









function parseFecha(fechaStr) {
    // Si viene como "dd/mm/yyyy"
    if (fechaStr.includes("/")) {
        var partes = fechaStr.split("/");
        // partes[0] = dia, partes[1] = mes, partes[2] = año
        return new Date(partes[2], partes[1] - 1, partes[0]);
    }
    return new Date(fechaStr); // Si ya viene en ISO
}






function check_status_payment(){

    var data_ = {
        user_id: user_id
    };

    $.ajax({
        url: URL_PHP + "Dashboard/obtener_pagos_usuario/",
        type: "POST",
        dataType: 'json',
        data: JSON.stringify(data_),
        success: function(response){

            console.log(JSON.stringify(response));

            global_param_pagos(response);
            
            var success = response.success;
            var total_pagos = response.total_pagos;
            
            // Nueva variable enviada desde el servidor
            var can_use_system = response.can_use_system; 

            if(total_pagos > 0){

                var fecha_ultimo_vencimiento = parseFecha(response.fecha_ultimo_vencimiento);
                
                // Días restantes desde HOY
                var fecha_actual = new Date(); 
                var diferencia = fecha_ultimo_vencimiento - fecha_actual;
                var dias = Math.ceil(diferencia / (1000 * 60 * 60 * 24));

                // Mostrar días restantes
                if (dias > 0) {
                    document.getElementById("ultimo_pago").innerText = dias + " more days.";
                } else {
                    document.getElementById("ultimo_pago").innerText = "0 days left.";
                }

                // Evaluamos la bandera directa del servidor
                if(can_use_system){

                    // PAGO VIGENTE
                    ver_arrecifes();

                    localStorage.setItem("active_account", 1);

                } else {

                    // PAGO VENCIDO
                    stripe_payment();

                    localStorage.setItem("active_account", 0);

                    ver_cortesias();
                }

                ver_datos_member();

            } else {

                /* DESPUES DEL REGISTRO, PERO NO HA REALIZADO NINGUN PAGO AUN */

                stripe_payment();

                document.getElementById("welcome_txt").style.display = "none";

                localStorage.setItem("active_account", 0);

                ver_cortesias();

                ver_datos_member();
            }
        }
    });
}



function global_param_pagos(response){

GLOBAL_PAYMENTS_JSON = response;


}






function stripe_payment(){
  // Le damos 50ms al DOM para asegurarse de que el modal/vista se dibuje por completo
  setTimeout(() => {
    const content_payment = document.getElementById("if_payment");

    if (!content_payment) return;

    content_payment.innerHTML = `
      <h2 align="center" style="color:#ffffff; font-size:15px;">
        With your contribution we keep growing!
      </h2><br>
      ${view_plans_payment()}
      <a class="btn plan-btn" style="background-color:#f98228" onclick="pago_stripe()">
         Contribute Now
      </a>
    `;

    convertirMXNaUSD("usd_transform", 199);
    convertirMXNaUSD("usd_transform_year", 499);
    convertirMXNaUSD("usd_transform_4_year", 899);

    const supportTime = document.getElementById("support_time");
    if (supportTime) supportTime.style.display = "none";
  }, 50); 
}






function pago_stripe(){


  const selectedPlan = getSelectedPlan();

  if(!selectedPlan){
    alertas({
      type: "error",
      title: "Select a plan",
      message: "Please select a subscription plan."
    });
    return;
  }


var content_payment = document.getElementById("if_payment");


   var stripe_ =  '<form id="payment-form" style="width:100%;background-color: #f0f2f37a;padding: 20px;border-radius: 10px;overflow: hidden;">'+


      '<div id="link-authentication-element">'+
     ' </div>'+
      '<div id="payment-element">'+
      '</div><br><br>'+
     ' <button class="btn btn-success" style="width:50%; float:right;" id="submit">'+
       ' <div class="spinner hidden" id="spinner"></div>'+
       ' <span id="button-text">Pay now</span>'+
      '</button>'+
     ' <div id="payment-message"></div>'+
    '</form>'





content_payment.innerHTML = stripe_;






/*




MODO PRUEBA
const stripe = Stripe("pk_test_51S5ujzRa4OxhItokKc1tIDuOaqCyCsKpWfyESDVkLx5RsFRDj3FyiRNwSyB69FC3xPizONRMtw6C3JNApMY71FlD00oDpqtum3");

MODO REAL
const stripe = Stripe("pk_live_51S5ujzRa4OxhItokWtLNkIFYRy39Tt2GsK2DUic5c6IEf6QiKpDBcPNazp4nGTDwmOgi3WT8Qk7G2QEi7C1e6XZy008KaShSdY");




var url_prod = "payment_stripe";
var url_test = "payment_stripe_test";
var url_usd= "payment_stripe_usd";
var url_usd_test= "payment_stripe_test_usd";

*/



/*PARA TESTEOS MODIFICAR ESTOS PARAMETROS*/
/*PARA TESTEOS MODIFICAR ESTOS PARAMETROS*/
/*PARA TESTEOS MODIFICAR ESTOS PARAMETROS*/
/*PARA TESTEOS MODIFICAR ESTOS PARAMETROS*/
/*PARA TESTEOS MODIFICAR ESTOS PARAMETROS*/

var url_= "payment_stripe";

const stripe = Stripe("pk_live_51S5ujzRa4OxhItokWtLNkIFYRy39Tt2GsK2DUic5c6IEf6QiKpDBcPNazp4nGTDwmOgi3WT8Qk7G2QEi7C1e6XZy008KaShSdY");

/*PARA TESTEOS MODIFICAR ESTOS PARAMETROS*/
/*PARA TESTEOS MODIFICAR ESTOS PARAMETROS*/
/*PARA TESTEOS MODIFICAR ESTOS PARAMETROS*/
/*PARA TESTEOS MODIFICAR ESTOS PARAMETROS*/
/*PARA TESTEOS MODIFICAR ESTOS PARAMETROS*/







let elements;

initialize(selectedPlan);
//checkStatus();

document.querySelector("#payment-form").addEventListener("submit", handleSubmit);




// Fetches a payment intent and captures the client secret
async function initialize(selectedPlan) {

  //var MONTO_TOTAL_PAGO = "345";





  

  const data = {
      amount: selectedPlan.price,
      user_email: user_id,
      nombre: user_id,
      plan: selectedPlan.plan,
      referencia_venta: reference_member
  };

const { clientSecret } = await fetch(
  "https://cozumel-reef-maps.com.mx/Stripe/" + url_ + "/?amount="+selectedPlan.price+"00&id_reserve="+user_id+"", 
{
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify(data)
}).then((r) => r.json());




  elements = stripe.elements({ clientSecret });

  const linkAuthenticationElement = elements.create("linkAuthentication");
  linkAuthenticationElement.mount("#link-authentication-element");

  const paymentElementOptions = {
    layout: "tabs",
  };

  const paymentElement = elements.create("payment", paymentElementOptions);
  paymentElement.mount("#payment-element");
}








async function handleSubmit(e) {
  e.preventDefault();
  setLoading(true);

  try {
    const { error, paymentIntent } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: "https://cozumel-reef-maps.com.mx/",
      },
      redirect: "if_required",
    });

    if (error) {
      alert_error(error.message);
      setLoading(false);
      return;
    }

    // --- OXXO, SPEI, etc ---
    if (paymentIntent.status === "requires_action") {
      // El cupón OXXO fue generado correctamente
      //alert("Tu cupón OXXO fue generado. Sigue las instrucciones en pantalla.");
      return; // No mostrar errores
    }

    // --- TARJETA ---
    if (paymentIntent.status === "succeeded") {
      actualizar_pago_user();
      return;
    }

    // Cualquier otro estado no es un error para OXXO
    console.log("Estado:", paymentIntent.status);

  } catch (err) {
    alert_error(err.message || "Error al procesar el pago");
  }

  setLoading(false);
}












// Show a spinner on payment submission
function setLoading(isLoading) {
  if (isLoading) {
    // Disable the button and show a spinner
    document.querySelector("#submit").disabled = true;
    document.querySelector("#spinner").classList.remove("hidden");
    document.querySelector("#button-text").classList.add("hidden");
  } else {
    document.querySelector("#submit").disabled = false;
    document.querySelector("#spinner").classList.add("hidden");
    document.querySelector("#button-text").classList.remove("hidden");
  }
}



}



function actualizar_pago_user(){




    var data_ = {
        user_id: user_id,
        total_pago: 199,
        external_reference_member:reference_member
    };

    $.ajax({
        url: URL_PHP + "Dashboard/nuevo_pago/",
        type: "POST",
        dataType: 'json',
        data: JSON.stringify(data_),
        success: function(response){
            var success = response.success;

            if(success == 1){




                  // ✅ Opción A: refresco inmediato
                    location.reload();

                
            } else {
                alert_error("Error. Try Latter")
            }
        }
    });





}







function alert_error(message){


const popup = document.createElement('div');
    popup.style.position = 'fixed';
    popup.style.top = '20%';
    popup.style.left = '50%';
    popup.style.transform = 'translateX(-50%)';
    popup.style.backgroundColor = '#ff4d4d';
    popup.style.color = '#fff';
    popup.style.padding = '20px';
    popup.style.borderRadius = '8px';
    popup.style.boxShadow = '0 2px 10px rgba(0,0,0,0.3)';
    popup.style.zIndex = '1000';
    popup.style.maxWidth = '300px';
    popup.style.textAlign = 'center';
    popup.style.fontFamily = 'Arial, sans-serif';

    // Mensaje de error
    const msg = document.createElement('span');
    msg.innerHTML = message;
    popup.appendChild(msg);

    // Botón de cerrar
    const closeBtn = document.createElement('button');
    closeBtn.innerText = 'Cerrar';
    closeBtn.style.marginTop = '10px';
    closeBtn.style.background = '#fff';
    closeBtn.style.color = '#ff4d4d';
    closeBtn.style.border = 'none';
    closeBtn.style.padding = '5px 10px';
    closeBtn.style.borderRadius = '5px';
    closeBtn.style.cursor = 'pointer';
    closeBtn.onclick = () => document.body.removeChild(popup);

    popup.appendChild(document.createElement('br'));
    popup.appendChild(closeBtn);

    document.body.appendChild(popup);

    // Opcional: auto-cierre después de 5 segundos
    setTimeout(() => {
      if (document.body.contains(popup)) {
        document.body.removeChild(popup);
      }
    }, 5000);



}



  const svg = {
    dive: '<svg class="icon-flag" width="18" height="18" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><rect x="0" y="0" width="24" height="24" fill="#ff0000"/><polygon points="0,24 24,0 27,2 2,28" fill="#ffffff"/></svg>'
  };





const diveSites = [

    {
    name: "Colombia Deep",
    url: "https://cozumel-reef-maps.com.mx/Index/reef/Colombia-Deep",
    depth: "25 to 35 meters",
    diveLevel: "Intermediate to advanced",
    currents: "Moderate",
    coralFormations: "Deep rocky corals and vertical structures"
  },{
    name: "Colombia Regular",
    url: "https://cozumel-reef-maps.com.mx/Index/reef/Colombia-Regular",
    depth: "12 to 25 meters",
    diveLevel: "All levels",
    currents: "Mild to moderate",
    coralFormations: "Coral gardens and rocks with abundant marine life"
  },{
    name: "Palancar Bricks",
    url: "https://cozumel-reef-maps.com.mx/Index/reef/Palancar-Bricks",
    depth: "18 to 28 meters",
    diveLevel: "Intermediate",
    currents: "Moderate",
    coralFormations: "Brick-like corals and coral gardens"
  },{
    name: "Palancar Caves",
    url: "https://cozumel-reef-maps.com.mx/Index/reef/Palancar-Caves",
    depth: "18 to 35 meters",
    diveLevel: "Intermediate to advanced",
    currents: "Moderate",
    coralFormations: "Caves and coral tunnels, sea fans"
  },{
    name: "Palancar Gardens",
    url: "https://cozumel-reef-maps.com.mx/Index/reef/Palancar-Gardens",
    depth: "10 to 20 meters",
    diveLevel: "Beginner to intermediate",
    currents: "Mild",
    coralFormations: "Coral gardens with a variety of hard and soft corals"
  },{
    name: "Dalila-Francesa",
    url: "https://cozumel-reef-maps.com.mx/Index/reef/Dalila-Francesa",
    depth: "12 to 25 meters",
    diveLevel: "Intermediate",
    currents: "Mild",
    coralFormations: "Mixed reefs with hard and soft corals"
  },{
    name: "El Cedral",
    url: "https://cozumel-reef-maps.com.mx/Index/reef/El-Cedral",
    depth: "10 to 20 meters",
    diveLevel: "Beginner to intermediate",
    currents: "Mild",
    coralFormations: "Coral gardens and small rock formations"
  },
  {
    name: "Santa Rosa Wall",
    url: "https://cozumel-reef-maps.com.mx/Index/reef/Santa-Rosa-Wall",
    depth: "15 to 40 meters (wall up to 300 m)",
    diveLevel: "Intermediate to advanced",
    currents: "Moderate to strong, ideal for drift diving",
    coralFormations: "Rocky corals, tubular sponges, sea fans"
  },{
    name: "San Clemente",
    url: "https://cozumel-reef-maps.com.mx/Index/reef/San-Clemente",
    depth: "10 to 32 meters",
    diveLevel: "Beginner",
    currents: "Mild to moderate",
    coralFormations: "Soft corals, tropical fish, and starfish"
  },{
    name: "Yucab",
    url: "https://cozumel-reef-maps.com.mx/Index/reef/Yucab",
    depth: "15 to 30 meters",
    diveLevel: "Intermediate",
    currents: "Moderate",
    coralFormations: "Soft corals, sea fans, and hard corals"
  },{
    name: "Tormentos",
    url: "https://cozumel-reef-maps.com.mx/Index/reef/Tormentos",
    depth: "15 to 35 meters",
    diveLevel: "Intermediate to advanced",
    currents: "Moderate to strong",
    coralFormations: "Hard corals, rocks, and sea fans"
  },{
    name: "Chankanab",
    url: "https://cozumel-reef-maps.com.mx/Index/reef/Chankanab",
    depth: "15 to 30 meters",
    diveLevel: "Intermediate",
    currents: "Mild to moderate",
    coralFormations: "Hard and soft corals, rocks, and coral gardens"
  },{
    name: "C53 Felipe Xicotencatl",
    url: "https://cozumel-reef-maps.com.mx/Index/mobil_joystick/C53-Felipe-Xicotencatl",
    depth: "15 to 30 meters",
    diveLevel: "Intermediate",
    currents: "Mild to moderate",
    coralFormations: "Hard and soft corals, rocks, and coral gardens"
  },{
    name: "Paraíso",
    url: "https://cozumel-reef-maps.com.mx/Index/reef/Paraiso",
    depth: "5 to 15 meters",
    diveLevel: "Beginner",
    currents: "Very mild",
    coralFormations: "Soft corals, tropical fish, and starfish"
  }
  
 
  
  
  
];




function ver_arrecifes() {
  document.getElementById("reefs_list").style.display = "block";
  const container = document.getElementById("dive_container_reefs");


   container.innerHTML += `
      <div class="col-lg-4 col-md-6" style="margin-bottom: 40px;">
          <a style="color:#419ace;" href="${URL_PHP}/Index/cozumel_map">
              <div class="snippets">
                  <h5>Cozumel Full Map</h5>

              <img src="${URL_PHP}/Views/Default/img/cozumel_dive_sites_map.jpg"/ style="width:90%; margin:0 auto;">
                 
                  <span>🪸</span>
              </div>
          </a>
      </div>
    `;



    container.innerHTML += `
      <div class="col-lg-4 col-md-6" style="margin-bottom: 40px;">
          <a style="color:#419ace;" href="${URL_PHP}/Index/mobil_joystick/C53-Felipe-Xicotencatl">
              <div class="snippets">
                   <h5>${svg.dive} C53 Felipe Xicotencatl</h5>

              <img src="${URL_PHP}/Views/Default/img/felipe_xicotencatl.jpg"/ style="width:90%; margin:0 auto;">
                 
                  <span>🪸</span>
              </div>
          </a>
      </div>
    `;


  diveSites.forEach(site => {
    container.innerHTML += `
      <div class="col-lg-4 col-md-6" style="margin-bottom: 40px;">
          <a style="color:#419ace;" href="${site.url}">
              <div class="snippets">
                  <h5>${svg.dive} ${site.name}</h5>
                  <ul style="list-style:circle; text-align:left;">
                      <li><strong>Depth:</strong> ${site.depth}</li>
                      <li><strong>Dive level:</strong> ${site.diveLevel}</li>
                      <li><strong>Currents:</strong> ${site.currents}</li>
                      <li><strong>Coral formations:</strong> ${site.coralFormations}</li>
                  </ul>
                  <span>🪸</span>
              </div>
          </a>
      </div>
    `;
  });




}





function ver_cortesias() {
  document.getElementById("reefs_list").style.display = "block";
  const container = document.getElementById("dive_container_reefs");


  container.innerHTML += `
      <div class="col-lg-4 col-md-6" style="margin-bottom: 40px;">
          <a style="color:#419ace;" href="${URL_PHP}/Index/cozumel_map">
              <div class="snippets">
                  <h5>Cozumel Full Map</h5>

              <img src="${URL_PHP}/Views/Default/img/cozumel_dive_sites_map.jpg"/ style="width:90%; margin:0 auto;">
                 
                  <span>🪸</span>
              </div>
          </a>
      </div>
    `;



    container.innerHTML += `
      <div class="col-lg-4 col-md-6" style="margin-bottom: 40px;">
          <a style="color:#419ace;" href="${URL_PHP}/Index/mobil_joystick/C53-Felipe-Xicotencatl">
              <div class="snippets">
                   <h5>${svg.dive} C53 Felipe Xicotencatl</h5>

              <img src="${URL_PHP}/Views/Default/img/felipe_xicotencatl.jpg"/ style="width:90%; margin:0 auto;">
                 
                  <span>🪸</span>
              </div>
          </a>
      </div>
    `;


      diveSites.forEach(site => {
    container.innerHTML += `
      <div class="col-lg-4 col-md-6" style="margin-bottom: 40px;">
          <a style="color:#419ace;" href="${site.url}">
              <div class="snippets">
                  <h5>${svg.dive} ${site.name}</h5>
                  <ul style="list-style:circle; text-align:left;">
                      <li><strong>Depth:</strong> ${site.depth}</li>
                      <li><strong>Dive level:</strong> ${site.diveLevel}</li>
                      <li><strong>Currents:</strong> ${site.currents}</li>
                      <li><strong>Coral formations:</strong> ${site.coralFormations}</li>
                  </ul>
                  <span>🪸</span>
              </div>
          </a>
      </div>
    `;
  });






}




/*

 function requiere_pago({
  texto = "Visualization blocked",
  duracionMs = 3000,
  zIndex = 999999
} = {}) {
  // Evitar duplicados
  const id = "popup_fullscreen_3s";
  const existente = document.getElementById(id);
  if (existente) existente.remove();

  // Capa principal
  const overlay = document.createElement("div");
  overlay.id = id;

  overlay.style.position = "fixed";
  overlay.style.left = "0";
  overlay.style.top = "0";
  overlay.style.width = "100vw";
  overlay.style.height = "100vh";
  overlay.style.zIndex = String(zIndex);
  overlay.style.display = "flex";
  overlay.style.alignItems = "center";
  overlay.style.justifyContent = "center";
  overlay.style.background = "rgba(0,0,0,0.55)";
  overlay.style.backdropFilter = "blur(4px)";
  overlay.style.webkitBackdropFilter = "blur(4px)";
  overlay.style.opacity = "0";
  overlay.style.transition = "opacity 180ms ease";
  overlay.style.pointerEvents = "auto"; // bloquea clicks debajo

  // Caja central
  const box = document.createElement("div");
  box.style.minWidth = "220px";
  box.style.maxWidth = "86vw";
  box.style.padding = "18px 18px";
  box.style.borderRadius = "14px";
  box.style.background = "rgba(15,18,22,0.92)";
  box.style.border = "1px solid rgba(255,255,255,0.12)";
  box.style.boxShadow = "0 12px 45px rgba(0,0,0,0.45)";
  box.style.color = "#fff";
  box.style.fontFamily = "system-ui, -apple-system, Segoe UI, Roboto, Arial";
  box.style.textAlign = "center";

  // Spinner simple (CSS inline)
  const spinner = document.createElement("div");
  spinner.style.width = "26px";
  spinner.style.height = "26px";
  spinner.style.margin = "0 auto 12px auto";
  spinner.style.borderRadius = "50%";
  spinner.style.border = "3px solid rgba(255,255,255,0.25)";
  spinner.style.borderTopColor = "rgba(255,255,255,0.95)";
  spinner.style.animation = "popupSpin 0.9s linear infinite";

  // Texto
  const label = document.createElement("div");
  label.textContent = texto;
  label.style.fontSize = "15px";
  label.style.lineHeight = "1.3";
  label.style.letterSpacing = "0.2px";

  box.appendChild(spinner);
  box.appendChild(label);
  overlay.appendChild(box);
  document.body.appendChild(overlay);

  // Keyframes para el spinner (inyectar una sola vez)
  const styleId = "popup_fullscreen_3s_styles";
  if (!document.getElementById(styleId)) {
    const style = document.createElement("style");
    style.id = styleId;
    style.textContent = `
      @keyframes popupSpin {
        from { transform: rotate(0deg); }
        to   { transform: rotate(360deg); }
      }
    `;
    document.head.appendChild(style);
  }

  // Mostrar (fade in)
  requestAnimationFrame(() => {
    overlay.style.opacity = "1";
  });

  // Ocultar y remover
  const t1 = setTimeout(() => {
    overlay.style.opacity = "0";
  }, Math.max(0, duracionMs - 180));

  const t2 = setTimeout(() => {
    overlay.remove();
    clearTimeout(t1);
  }, duracionMs);

  // Por si quieres cancelarlo manualmente:
  return () => {
    clearTimeout(t1);
    clearTimeout(t2);
    if (overlay?.parentNode) overlay.remove();
  };
}



*/

     





function ver_datos_member(){

  const img = document.getElementById("logo_member_img");
  const DEFAULT_LOGO = URL_PHP + "Views/Default/img/logo_oficial_small.png";

  // 1️⃣ no hay reference_member
  if (!reference_member || reference_member === "null") {

    // 👉 guardar default en localStorage
    localStorage.setItem("member_logo_url", DEFAULT_LOGO);
    localStorage.setItem("member_url_web", URL_PHP);

    // 👉 asignar imagen
    if (img) img.src = DEFAULT_LOGO;

    return;
  }

  $.ajax({
    url: URL_PHP + "Dashboard/search_img_member/?reference_member=" + reference_member,
    type: "POST",
    dataType: "json",
    success: function(response){

      console.log("DATA::", response);

      // 2️⃣ respuesta inválida
      if (!response || !response.img_logo) {

        localStorage.setItem("member_logo_url", DEFAULT_LOGO);
        localStorage.setItem("member_url_web", "");

        if (img) img.src = DEFAULT_LOGO;
        return;
      }

      // 3️⃣ guardar en localStorage
      localStorage.setItem("member_logo_url", response.img_logo);
      localStorage.setItem("member_url_web", response.web ?? "");

      // 4️⃣ asignar imagen
      if (img) img.src = response.img_logo;
    },
    error: function(){

      // 5️⃣ error de red
      localStorage.setItem("member_logo_url", DEFAULT_LOGO);
      localStorage.setItem("member_url_web", "");

      if (img) img.src = DEFAULT_LOGO;
    }
  });
}



//window.requiere_pago = requiere_pago;
window.pago_stripe = pago_stripe;
window.view_payments = view_payments;